import './vehicle-info.scss';

import { useState } from 'react';

import { BankNames } from '@/constants';
import EditIcon from '@/media/icons/edit.svg?react';
import InfoCircleIcon from '@/media/icons/info-circle.svg?react';
import { useAppSelector } from '@/store';

import { banksToShowVehicleInfo } from '../../constants';
import { VehicleModal } from '../../entities';

const extendedBanksToShowVehicleInfo = [
  ...banksToShowVehicleInfo,
  BankNames.altyn
];

const changeButtonTextStatuses = [
  'financed',
  'waiting_of_financing',
  'waiting_for_upload_files',
  'on_rework',
  'refund_in_progress',
  'refunded'
];

const VehicleInfo: React.FC = () => {
  const { selectedBank, isVehicleInfoValid } = useAppSelector(
    (state) => state.financingStep
  );
  const { tsModalValues } = useAppSelector((state) => state.newOrder);

  const [showVehicleModal, setShowVehicleModal] = useState(false);

  const shouldShowMoreInfo =
    selectedBank?.bank.name === BankNames.euBankV2
      ? changeButtonTextStatuses.includes(selectedBank?.status.code || '')
      : selectedBank?.status.code === 'financed';
  const shouldShowVehicleInfo =
    extendedBanksToShowVehicleInfo.includes(
      selectedBank?.bank.name as BankNames
    ) && isVehicleInfoValid;

  return (
    <>
      <div className="vehicle-info">
        <div className="vehicle-info__title-wrapper">
          <h2 className="vehicle-info__title">Данные ТС</h2>
          <button
            className="vehicle-info__action"
            onClick={() => setShowVehicleModal(true)}
          >
            <span className="vehicle-info__action-text">
              {shouldShowMoreInfo
                ? 'Подробнее'
                : shouldShowVehicleInfo
                  ? 'Изменить'
                  : 'Добавить'}
            </span>{' '}
            {selectedBank?.status.code !== 'financed' ? (
              <EditIcon />
            ) : (
              <span className="vehicle-info__action-hidden">
                <InfoCircleIcon />
              </span>
            )}
          </button>
        </div>

        <div className="vehicle-info__content">
          {shouldShowVehicleInfo ? (
            <>
              <p className="vehicle-info__vin">{`VIN: ${tsModalValues.vin}`}</p>
              {tsModalValues.licensePlate && (
                <h2 className="vehicle-info__license">
                  {tsModalValues.licensePlate}
                </h2>
              )}
            </>
          ) : (
            <p className="vehicle-info__no-data">Нет данных</p>
          )}
        </div>
      </div>

      <VehicleModal
        isOpened={showVehicleModal}
        onClose={() => setShowVehicleModal(false)}
      />
    </>
  );
};

export default VehicleInfo;
